module.exports = __webpack_public_path__ + "img/h2_bg02.da5a33c0.png";